module.exports = __webpack_public_path__ + "img/collection-weddingRingsBestseller.87ed597.webp";